import React from "react";
const StatusRightContent = ({ t, status }) => {
    return (
        <>
            {t.progression_id === 8 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#819FEC" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 9 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#7FCECE" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 10 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#E7B8DF" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 11 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 12 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 13 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#FFA500" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 14 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#660000" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 15 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 16 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 17 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#F0BE74" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 19 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#7f7f7f" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 20 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#e6e612" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 21 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#FF0000" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : t.progression_id === 22 ? (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#0000FF" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            ) : (
                <div className="app-circle right-info">
                    <i
                        className="fa fa-circle"
                        aria-hidden="true"
                        style={{ color: "#44AE42" }}
                    />
                    <p title={status}>{status}</p>
                </div>
            )}
        </>
    );
};

export default StatusRightContent;
